import { BehaviorSubject } from 'rxjs';
export const getEditCompanyFormStore = () => {
    const getInitialState = () => ({
        companyDetails: {
            id: 0,
            clientDetails: {
                clientName: '',
                availableCompaniesNo: null,
                roles: []
            },
            fiscalIdentifier: '',
            activityCode: '',
            name: '',
            address: '',
            phoneNumber: '',
            faxNumber: '',
            email: '',
            taxType: null,
            isBank: null,
            roles: [],
            appointee: null,
            signer: {
                firstName: '',
                lastName: '',
                role: ''
            },
            fiscalYearType: null,
            fiscalYear: null,
            hasCalculations: null
        },
        companyRolesWithRelatedRoles: []
    });
    const editCompanyFormSubject = new BehaviorSubject(getInitialState());
    const subscribe = (callback) => editCompanyFormSubject.subscribe(callback);
    const setCompanyDetails = (companyDetails) => {
        editCompanyFormSubject.next({
            ...editCompanyFormSubject.getValue(),
            companyDetails: companyDetails
        });
    };
    const setCompanyRolesWithRelatedRoles = (companyRolesWithRelatedRoles) => {
        editCompanyFormSubject.next({
            ...editCompanyFormSubject.getValue(),
            companyRolesWithRelatedRoles: companyRolesWithRelatedRoles
        });
    };
    const getCompanyRolesWithRelatedRoles = () => editCompanyFormSubject.getValue().companyRolesWithRelatedRoles;
    const reset = () => {
        editCompanyFormSubject.next(getInitialState());
    };
    return {
        getInitialState,
        subscribe,
        setCompanyDetails,
        setCompanyRolesWithRelatedRoles,
        getCompanyRolesWithRelatedRoles,
        reset
    };
};
